import { defineStore } from 'pinia'
import { useUserStore } from '@/stores/user.store.ts'
import { computed, ref, watchEffect } from 'vue'
import type { AppTranslations, TranslationFunction } from '@/locales/types.ts'
import { flatten } from 'flat'

export const useTranslationStore = defineStore('translation', () => {
  const userStore = useUserStore()
  const translations = ref<AppTranslations>({} as AppTranslations)
  const flatTranslations = ref<Record<string, string>>({})
  const isLoaded = ref(false)

  const localeLanguage = computed(() => userStore.localeLanguage)

  const loadTranslations = async () => {
    try {
      const module = await import(`@/locales/${localeLanguage.value}.ts`)
      translations.value = module.default
      flatTranslations.value = flatten(translations.value) as Record<string, string>
      isLoaded.value = true
    } catch (error) {
      console.error('Failed to load translations:', error)
      isLoaded.value = false
    }
  }

  // watchEffect(() => {
    loadTranslations()
  //)

  const t: TranslationFunction = (
    key: string,
    params?: Record<string, string | number>
  ): string => {
    const translation = flatTranslations.value[key]
    const fallback = translation || key

    if (isLoaded.value && !translation && process.env.NODE_ENV === 'development') {
      console.warn(`Missing translation key: "${key}" for locale "${localeLanguage.value}"`)
    }

    if (params == null) return fallback

    return fallback.replace(/{(\w+)}/g, (_, paramKey) => {
      return paramKey in params ? String(params[paramKey as keyof typeof params]) : _;
    });
  };

  return {
    isLoaded,
    translations,
    t,
    localeLanguage,
  }
})
